import React, { useEffect, useContext, memo } from 'react';
import { createPortal } from 'react-dom';
import ModalContext from '../contexts/modal.js';
import '../styles/modal.css';

const Modal = ({
    modalContent = null,
    modalActions = [],
    title = "",
    icon = null,
    fullScreen = true,
    maxWidth = "lg",
    onExit = () => {}
}) => {
    const { modalActive, setModalActive } = useContext(ModalContext);

    const exit = () => {
        onExit();
        setModalActive(false);
    };

    useEffect(() => {
        if(modalActive) {
            return document.body.classList.add("no-scroll");
        }
        return document.body.classList.remove("no-scroll");
    }, [modalActive]);

    if(modalActive) {
        return createPortal(
            <div
                className={`modal ${fullScreen ? "fullScreen" : ""}`}
                style={{ maxWidth }}
            >
                <div className="modal-toolbar">
                    <div className="modal-heading">
                        { icon && <img className="modal-icon" src={icon} alt="" /> }
                        { title && <span className="modal-title">{title}</span> }
                    </div>
                    <div className="modal-actions">
                        { modalActions.map((modalAction, index) => (
                            <button key={index} onClick={modalAction.callback}>{modalAction.text}</button>
                        )) }
                    </div>
                    <button className="modal-exit" onClick={exit} aria-label="close" title="Close modal">Close</button>
                </div>
                <div className="modal-content">
                    { modalContent }
                </div>
            </div>,
            document.body
        );
    }
    return null;
};

// Modal.displayName = "SingleImageFilePicker";

export default memo(Modal);
